import env from "./env";
import axios from "axios";

const reachApi = axios.create({
  baseURL: env.PROJECT19_API_ROOT,
  headers: {
    Accept: "application/json"
  },
  timeout: 5000,
  validateStatus: status => status >= 200 && status < 500,
  withCredentials: true
});

export default reachApi;
